import {Box, Button, Modal, Typography} from '@mui/material'
import {useContext, useState} from 'react'
import styled from 'styled-components'
import archiveIcon from '../../../../../assets/archive.svg'
import {threadType} from '../../../../../types/thread'
import {getCurrentColors} from '../../../../../utils/colors'
import {HistoryContext} from '../../../../../contexts/history'
import AttachFileIcon from '@mui/icons-material/AttachFile'

interface ListItemProps {
    item: threadType
    isSelected: boolean
    onSelect: () => void
}

const COLORS = getCurrentColors() // Importando as cores do tema atual

const ListItemStyled = styled.li<{isSelected: boolean}>`
    font-weight: 300;
    background-color: ${({isSelected}) =>
        isSelected ? COLORS.cinzaClaro : 'transparent'};
    cursor: pointer;
    width: calc(100%);
    padding: 8px 16px;
    border-radius: 5px;
    font-size: 15px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2px 0;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${COLORS.cinzaClaro};
    }
`

const ItemContent = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    min-width: 0;
`

const ItemName = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    color: black;
    font-weight: 400;
`

const ItemTime = styled.span`
    font-size: 12px;
    color: ${COLORS.cinzaEscuro};
`

const Icons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
`

export default function ListItem({item, isSelected, onSelect}: ListItemProps) {
    const {selected, setSelected, archiveThread, deleteThread} =
        useContext(HistoryContext)
    const [openModal, setOpenModal] = useState(false)

    const handleArchiveClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const formattedTime = new Date(item.created_at).toLocaleTimeString(
        'pt-BR',
        {
            hour: '2-digit',
            minute: '2-digit',
        }
    )

    return (
        <>
            <ListItemStyled isSelected={isSelected} onClick={onSelect}>
                <ItemContent>
                    {item.uploaded_documents >= 1 && (
                        <AttachFileIcon
                            sx={{
                                fontSize: 16,
                                marginRight: '8px',
                                color: COLORS.secundariaEscura,
                            }}
                        />
                    )}
                    <ItemName>{item.name}</ItemName>
                </ItemContent>

                {isSelected && item.name !== 'Novo Chat' && (
                    <Icons>
                        <img
                            src={archiveIcon}
                            alt="Arquivar"
                            onClick={handleArchiveClick}
                            style={{
                                cursor: 'pointer',
                                width: '20px',
                                height: '20px',
                            }}
                        />
                    </Icons>
                )}
            </ListItemStyled>

            <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 300,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="h6" component="h2">
                        Confirmar Arquivamento
                    </Typography>
                    <Typography sx={{mt: 2}}>
                        Tem certeza que deseja arquivar a conversa{' '}
                        <b style={{color: COLORS.azulClaro}}>{item.name}</b>?
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            mt: 3,
                        }}
                    >
                        <Button onClick={handleCloseModal} sx={{mr: 1}}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => {
                                archiveThread(item.guid)
                                handleCloseModal()
                            }}
                        >
                            Arquivar
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    )
}
